import axios from 'axios';
export function modifyAxiosDefaults(configuration, isServer, waKey) {
  if (isServer) {
    modifyAxiosDefaultsServer(configuration, waKey);
  }
}

function modifyAxiosDefaultsServer(configuration, waKey) {
  const {
    appName,
    appVersion,
    serverName,
    serverVersion
  } = configuration;
  axios.defaults.headers.common['User-Agent'] = serverName + "/<" + serverVersion + "> " + appName + "/<" + appVersion + ">";

  if (configuration.isPartnerFunnel) {
    axios.defaults.params = { ...axios.defaults.params,
      wa_key: waKey
    };
  }
}

const createPartnerFunnelInterceptor = appConfig => reqConfig => {
  if (appConfig.isPartnerFunnel && typeof window !== 'undefined') {
    if (!reqConfig.params) {
      reqConfig.params = {};
    }

    reqConfig.params['wa_key'] = new URL(window.location.href).searchParams.get('wa_key');
  }

  return reqConfig;
};

const getHeaderCaseInsensitive = (headers, name) => {
  const key = Object.keys(headers).find(key => key.toLowerCase() === name.toLowerCase());
  return key ? headers[key] : '';
};

const addTracingInterceptor = axios => {
  axios.interceptors.response.use(response => response, error => {
    try {
      var _error$config, _error$response;

      error.apiUrl = (_error$config = error.config) === null || _error$config === void 0 ? void 0 : _error$config.url;
      error.traceId = getHeaderCaseInsensitive(((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.headers) || {}, 'X-B3-Traceid');
    } catch (error) {
      console.error('Error while adding tracing interceptor', error);
    }

    return Promise.reject(error);
  });
};

export function createAxiosClient(config, appConfig) {
  const axiosInstance = axios.create(config);
  axiosInstance.interceptors.request.use(createPartnerFunnelInterceptor(appConfig));
  addTracingInterceptor(axiosInstance);
  return axiosInstance;
}